import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../utils/api';

const NAVY = '#0d2137';

export default function ChangePassword() {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.current_password || !form.new_password || !form.confirm_password) {
      toast.error('Please fill all fields');
      return;
    }
    if (form.new_password.length < 6) {
      toast.error('New password must be at least 6 characters');
      return;
    }
    if (form.new_password !== form.confirm_password) {
      toast.error('New passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/change-password', {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success('Password changed successfully!');
      setForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 32, maxWidth: 480, margin: '40px auto' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '32px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)' }}>
        <h2 style={{ color: NAVY, marginBottom: 24, fontSize: 20, fontWeight: 800 }}>Change Password</h2>

        <form onSubmit={handleSubmit}>
          {[
            { label: 'Current Password', key: 'current_password' },
            { label: 'New Password', key: 'new_password' },
            { label: 'Confirm New Password', key: 'confirm_password' },
          ].map(({ label, key }) => (
            <div key={key} style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                {label}
              </label>
              <input
                type="password"
                value={form[key]}
                onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: 7,
                  border: '1.5px solid #d1d5db', fontSize: 14, outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
            </div>
          ))}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '11px', borderRadius: 7, marginTop: 8,
              background: loading ? '#94a3b8' : NAVY,
              color: '#fff', fontWeight: 700, fontSize: 15,
              border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Changing...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
